module.exports = __webpack_public_path__ + "static/media/briefcase.8cd64fd5.svg";